import { Injectable } from '@angular/core';
import { HttpContext } from '@angular/common/http';

import { HttpService } from '@/app/core/services/http';

import { CredentialsInfo, RefreshTokenResponse } from './auth.types';

import { ALLOW_REFRESH } from '@/app/core/interceptors';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpService) {}

  sendLoginLink(email: string) {
    return this.http.post<void>('auth/login/link', { email }, { context: new HttpContext().set(ALLOW_REFRESH, false) });
  }

  verifyLoginLink(email: string, code: string) {
    return this.http.post<CredentialsInfo>(
      'auth/login/by-code',
      { email, code },
      { context: new HttpContext().set(ALLOW_REFRESH, false) },
    );
  }

  logout() {
    return this.http.delete('auth/logout');
  }

  refreshToken() {
    return this.http.post<RefreshTokenResponse>('auth/refresh', null, {
      context: new HttpContext().set(ALLOW_REFRESH, false),
      skipHandleError: true,
    });
  }
}
